import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Layout, Menu, Divider } from "antd";
import { MENU_ITEMS, GetCurrentMainRoute, } from "navigation/CONSTANTS";
import collapseIcon from '../../assets/icons/ic_collapse.svg'
import "./SidebarWidget.css";

import { IconWidget } from "components/IconWidget/IconWidget";

import { ChangeMenuCollapsed, UpdateCurrentRoot } from "redux/actions/appActions";
import { apiGetMenuPermissions } from "services/dashboardService";
import buildInfo from '../../buildInfo.json';

const SidebarWidget = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const appDataStore = useSelector(x => x.appDataStore);
    const userDataStore = useSelector(x => x.userDataStore);
    const { collapsed, width } = appDataStore;
    const url = history.location.pathname;
    const mainRoute = GetCurrentMainRoute(url);

    const [enabledMenus, setEnabledMenus] = useState(null);

    // Fetch menu permissions when club is loaded
    useEffect(() => {
        if (appDataStore.club && appDataStore.club.id && userDataStore.token) {
            const params = new URLSearchParams();
            params.append("token", userDataStore.token);
            params.append("club_id", appDataStore.club.id);

            apiGetMenuPermissions(params)
                .then((res) => {
                    if (res && res.enabled_menus) {
                        setEnabledMenus(res.enabled_menus);
                    } else {
                        // If no permissions returned, show all menus (default behavior)
                        setEnabledMenus(MENU_ITEMS.map(item => item.route));
                    }
                })
                .catch((err) => {
                    // On error, show all menus (default behavior)
                    setEnabledMenus(MENU_ITEMS.map(item => item.route));
                });
        }
    }, [appDataStore.club, userDataStore.token]);

    // Filter menu items based on permissions
    const filteredMenuItems = useMemo(() => {
        // If permissions haven't loaded yet, show all menus temporarily
        if (enabledMenus === null) {
            return MENU_ITEMS;
        }

        // Filter menu items to only show enabled ones or always visible ones
        const filtered = MENU_ITEMS.filter(item => item.alwaysVisible || enabledMenus.includes(item.route));
        return filtered;
    }, [enabledMenus]);

    const menuItems = filteredMenuItems.map((info) => ({
        key: info.route,
        icon: info.icon,
        label: info.title,
        className: "c-menu-item",
        onClick: () => {
            history.push(info.route)
        }
    }))

    const onToggleCollapsed = () => {
        dispatch(ChangeMenuCollapsed({ collapsed: !collapsed }))
    }
    return (
        <div>
            <div className="logo">
                {
                    !collapsed ?
                        <div>
                            <img
                                src={'/assets/images/logo-large.png'}
                                alt="BeClutch"
                                className="logo-img"
                            />
                            <span style={{ float: 'right', fontSize: '1.0rem' }}>Ver {buildInfo.version} (Build: {buildInfo.buildNumber})</span>
                        </div>
                        : <div>
                            <div style={{ marginTop: 30, marginBottom: 10 }}><span style={{ fontSize: '1.4rem', fontFamily: "semiBoldFont", marginLeft: 0 }}>BeClutch</span></div>
                            <div><span style={{ fontSize: '1.0rem', marginLeft: 0 }}>Ver {buildInfo.version}</span></div>
                            <div><span style={{ fontSize: '0.8rem', marginLeft: 0 }}>Build: {buildInfo.buildNumber}</span></div>
                        </div>
                }
                {
                    width > 1024 ?
                        <div className="side-collapse" onClick={() => { onToggleCollapsed(); }}>
                            <IconWidget Icon={collapseIcon} />
                        </div>
                        : <div></div>}
            </div>
            <Divider />
            <div className="layout-store-name"></div>
            <Menu
                mode="inline"
                defaultSelectedKeys={[mainRoute]}
                selectedKeys={[mainRoute]}
                className="c-menu"
                onSelect={(v) => {
                    dispatch(UpdateCurrentRoot({ currentRoute: v.key }))
                }}
                items={menuItems}
            />
            <Layout>
                {props.children}
            </Layout>
        </div>
    );
};

export default SidebarWidget;